import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import Vote from './Vote.js';

import './styles/style.scss';

class App extends React.Component {
    render() {
        return (
            <Switch>
                <Route exact path="/vote" component={Vote} />
                <Redirect to="/vote" />
            </Switch>
        )
    }
}

export default App;